import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "bc78-cookie-consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Consentement aux cookies"
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[90] rounded-2xl bg-white/90 backdrop-blur-xl border border-slate-200 shadow-[0_20px_60px_rgb(15,23,42,0.18)] p-5"
        >
          <div className="flex items-start gap-3.5">
            <div className="w-10 h-10 rounded-xl bg-violet-100 flex items-center justify-center shrink-0">
              <Cookie size={18} className="text-violet-700" />
            </div>
            <div>
              <p className="font-heading font-bold text-slate-900 text-sm">Nous respectons votre vie privée</p>
              <p className="text-xs text-slate-500 leading-relaxed mt-1.5">
                Ce site utilise uniquement des cookies essentiels à son bon fonctionnement, sans traceur publicitaire.{" "}
                <Link to="/mentions-legales" className="text-violet-700 font-semibold hover:underline" data-testid="cookie-more-link">
                  En savoir plus
                </Link>
              </p>
            </div>
          </div>
          <div className="flex gap-2.5 mt-4">
            <button
              data-testid="cookie-accept-button"
              onClick={() => choose("accepted")}
              className="btn-shine flex-1 rounded-full bg-violet-700 text-white text-sm font-bold py-2.5 hover:bg-violet-800 transition-colors duration-200"
            >
              Tout accepter
            </button>
            <button
              data-testid="cookie-refuse-button"
              onClick={() => choose("refused")}
              className="flex-1 rounded-full border border-slate-200 text-slate-600 text-sm font-bold py-2.5 hover:border-violet-300 hover:text-violet-700 transition-colors duration-200"
            >
              Refuser
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
